import React from 'react';
import styled from 'styled-components';

import { PaperStyle } from '~/atomic/atom/PaperStyle';
import { Skeleton, SkeletonButton } from '~/atomic/atom/Skeleton';
import { lessThan } from '~/lib/mediaQuery';

export const AbonnementPageCardDummy = () => {
  return (
    <SCBookSubscriptionsCard>
      <SCInfo>
        <Skeleton paragraph={{ rows: 3 }} active />
      </SCInfo>
      <SCControls>
        <SkeletonButton active size="large" style={{ width: 230 }} />
        <Skeleton paragraph={{ rows: 1 }} title={false} active />
      </SCControls>
    </SCBookSubscriptionsCard>
  );
};

const SCBookSubscriptionsCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  ${PaperStyle};
  padding: 24px 30px;
  gap: 16px;

  ${lessThan('xs')} {
    padding: 20px 12px;
    flex-direction: column;
  }
`;

const SCInfo = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 520px;
  width: 100%;

  > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const SCControls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;

  > *:not(:last-child) {
    margin-bottom: 16px;
  }
  
  .ant-skeleton-paragraph {
    display: flex;
    justify-content: center;
  }
`;
